import DocumentosTab from "./DocumentosTab";
import { useDispatch, useSelector } from "react-redux";
import {
  getDetalhesParceiro,
  getDocumentos,
  getQuantidadeDocumentosPendentes,
  getQuantidadeDocumentosObrigatorios,
  isBaixandoArquivos,
  isBaixandoTemplates,
  isCarregandoDocumentos,
  isRemovendoArquivos,
  isSubindoArquivos,
} from "../../selectors/parceiro.selectors";
import { useCallback } from "react";
import { actions } from "../../actions/parceiro.actions";
import { actions as workflowActions } from "../../actions/workflow.actions";
import { actions as documentoActions } from "../../actions/documentos.actions";
import { toast } from "react-toastify";
import { getUsuarioLogado } from "../../selectors/usuario.selectors";

const DocumentosTabConnected = () => {
  const dispatch = useDispatch();
  const parceiro = useSelector(getDetalhesParceiro);
  const data = useSelector(getDocumentos);
  const uploading = useSelector(isSubindoArquivos);
  const downloading = useSelector(isBaixandoArquivos);
  const templating = useSelector(isBaixandoTemplates);
  const deleting = useSelector(isRemovendoArquivos);
  const loading = useSelector(isCarregandoDocumentos);
  const usuario = useSelector(getUsuarioLogado);

  const dataComPendencias = data.map((c) => ({
    ...c,
    pendentes: getQuantidadeDocumentosPendentes([c]),
    obrigatorios: getQuantidadeDocumentosObrigatorios([c]),
  }));

  const handleUpload = useCallback(
    ({ id, padrao, arquivos }, ok, nok) => {
      if (nok.length > 0) {
        toast.error("");
      } else {
        switch (padrao) {
          case "IA":
            dispatch(
              documentoActions.exibirIA(true, {
                id,
                files: ok,
              })
            );
            break;
          default:
            dispatch(actions.uploadDocumento.request({ id, files: ok }));
            break;
        }
      }
    },
    [dispatch]
  );
  const handleDownload = useCallback(
    ({ tipo, id }) => {
      dispatch(actions.downloadDocumento.request({ tipo, id }));
    },
    [dispatch]
  );
  const handleTemplate = useCallback(
    ({ id, preencherAutomaticamente = false }) => {
      dispatch(actions.downloadTemplate.request({ id, preencherAutomaticamente }));
    },
    [dispatch]
  );
  const handleDelete = useCallback(
    ({ id }, documento) => {
      dispatch(actions.removerArquivo.request({ id, documento }));
    },
    [dispatch]
  );
  const handleAddDocument = useCallback(
    (e, chk) => {
      e.stopPropagation();
      dispatch(
        workflowActions.exibirDocumentoManual({
          show: true,
          id: parceiro.id,
          tipo: "parceiro",
          checklist: chk,
        })
      );
    },
    [dispatch, parceiro]
  );

  return (
    <DocumentosTab
      data={dataComPendencias}
      loading={loading}
      handleUpload={handleUpload}
      handleDownload={handleDownload}
      handleDelete={handleDelete}
      handleTemplate={handleTemplate}
      handleAddDocument={handleAddDocument}
      uploading={uploading}
      downloading={downloading}
      deleting={deleting}
      templating={templating}
      perfil={usuario.perfil}
    />
  );
};

export default DocumentosTabConnected;
